import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";
interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
  phone: string;
  state: string;
}
const fetchUsers = async (): Promise<User[]> => {
  const allUsers: User[] = [];
  let page = 1;
  let hasMoreData = true;

  while (hasMoreData) {
    const { data } = await apiClient.get(`/users?limit=50&page=${page}`);

    if (data.status !== "success" || !Array.isArray(data.data)) {
      throw new Error("Invalid response format");
    }

    const users = data.data;
    allUsers.push(...users);

    // If we get less than 50 users, we've reached the last page
    if (users.length < 50) {
      hasMoreData = false;
    } else {
      page++;
    }
  }

  return allUsers;
};
export const useUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: fetchUsers,
  });
};

export const useOperators = () => {
  return useQuery({
    queryKey: ["operators"],
    queryFn: async () => {
      const allUsers = await fetchUsers();
      return allUsers.filter((user: User) => user.role === "Operator");
    },
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, state, role }: { id: string; state: string; role: string }) => {
      const response = await apiClient.patch(`/users/update/${id}`, { state, role });
      return response.data; // Ensure we return the updated user
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
